import ScrollReveal from '@/components/base/ScrollReveal';

export default function Bonus() {
  return (
    <section className="relative bg-foreground-50 py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image side */}
          <ScrollReveal>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden bg-white border border-foreground-100 shadow-[0_12px_40px_rgba(0,0,0,0.06)]">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20digital%20prompt%20template%20organizer%20mockup%20elegant%20white%20and%20gold%20design%20premium%20productivity%20tool%20interface%20soft%20lighting%20professional%20UI%20design%20grid%20layout%20beautiful%20typography&width=800&height=600&seq=prompts-bonus-mockup&orientation=landscape"
                  alt="Plantillas para videos"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
              {/* Value badge */}
              <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-primary-500 text-white px-4 py-2 rounded-xl shadow-[0_4px_16px_rgba(229,57,53,0.3)]">
                <span className="text-xs font-bold uppercase tracking-wider">Valor</span>
                <span className="block text-lg font-bold">$15.000 COP</span>
              </div>
            </div>
          </ScrollReveal>

          {/* Text side */}
          <div>
            <ScrollReveal>
              <span className="inline-block px-3 py-1 rounded-md bg-accent-500 text-white text-xs font-bold tracking-wider uppercase mb-4">
                BONUS EXCLUSIVO
              </span>
            </ScrollReveal>

            <ScrollReveal delay={0.1}>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                Plantillas para videos
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.15}>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
                Además de los 1500+ prompts, recibirás plantillas para crear videos en flow y Veo3, categorizar y personalizar todos tus prompts de IA. Nunca más perderás una buena instrucción.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <ul className="space-y-3 mb-8">
                {[
                  'Sistema de categorización por plataforma',
                  'Espacio para notas y personalización',
                  'Filtros por objetivo de campaña',
                  'Diseño limpio y profesional',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-accent-600 text-xs" />
                    </div>
                    <span className="text-foreground-700 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </ScrollReveal>

            <ScrollReveal delay={0.25}>
              <a
                href="#final-cta"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-all duration-300 shadow-[0_4px_20px_rgba(229,57,53,0.25)] hover:shadow-[0_8px_30px_rgba(229,57,53,0.35)] hover:-translate-y-0.5 whitespace-nowrap"
              >
                Obtener Ahora
                <i className="ri-arrow-right-line" />
              </a>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}